export default __webpack_public_path__ + "static/media/history-temple.bf19bc4e.png";